import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@trevor/ui-components';
import { get, post, userAction } from '@/util/helpers/ajax-helpers';
import JoinDelta from '../../util/JoinDelta';
import TableRef from '../../util/TableRef';
import ColumnRef from '../../util/ColumnRef';
import SchemaColumn from '../../util/SchemaColumn';
import style from '../../css/module/tables.css';
import ConfigurePage from './ConfigurePage';
import ModalContent from '../ModalContent';
import SearchInput from '../SearchInput';
import SelectTables_LEGACY from './SelectTables_LEGACY';
import flex from '../../css/module/flex.css';
import { closeReactModal, loadTables, openReactModal } from '../../actions';

const TABLE1 = 'table1';
const TABLE2 = 'table2';
const COLUMN1 = 'column1';
const COLUMN2 = 'column2';

class SelectJoins extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [], // a list of tables loaded from server
      columns: [], // a list of columns loaded from server
      existing: [], // existing join deltas loaded from server
      updated: [], // an array of new join deltas (to be added and removed)
      joinWizards: [], // an array of arrays of objects, where the nested array matches a table and the objects contain the details for a new delta
      loading: true,
      loadError: false,
      savingInProcess: false,
      searchQuery: '',
    };
    this.applyJoinDelta = this.applyJoinDelta.bind(this);
    this.addJoinWizard = this.addJoinWizard.bind(this);
    this.stageJoinUsingWizard = this.stageJoinUsingWizard.bind(this);
    this.addUpdatedDelta = this.addUpdatedDelta.bind(this);
    this.removeWizard = this.removeWizard.bind(this);
    this.onSave = this.onSave.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    get('loading tables', '/configuration?joins=true')
      .then((json) => {
        this.setState({
          tables: json._tables.map((t) => TableRef.buildFromServer(t)),
          columns: json._tableColumns.map((cols) =>
            cols.map((c) => new SchemaColumn(c._name, c._type)),
          ),
          existing: json._fks.map((fk) => JoinDelta.buildFromServer(fk)),
          updated: [],
          joinWizards: json._tables.map(() => []),
          loading: false,
        });
      })
      // TODO: handle this error properly
      .catch(() => {
        userAction('problem-loading-join-page-customize-datasource');
        // force intercom to trigger a ping
        setTimeout(function () {
          const ts = Math.round(new Date().getTime() / 1000);
          Intercom('update', { dummy_attribute: ts });
        }, 3000);
        this.setState({
          loadError: true,
          loading: false,
        });
      });
    userAction('visit-customize-datasource-joins');
  }

  /*
   * takes this.state.existing and this.state.updated, merges them together,
   *  and builds a map, mapping table names to the list of JoinDeltas for that table
   */
  joinsPerTable(added = {}, deleted = {}) {
    const result = {}; // maps tables to list of JoinDeltas
    this.state.tables.map((t) => {
      // initialise with empty arrays for each table
      result[t.uniqueName()] = [];
      added[t.uniqueName()] = [];
      deleted[t.uniqueName()] = [];
    });
    const update = (delta, isChanges) => {
      const leftTable = delta.left().tov(); // TableRef
      const tableJoins = result[leftTable.uniqueName()];
      const addedJoins = added[leftTable.uniqueName()];
      const deletedJoins = deleted[leftTable.uniqueName()];
      if (!tableJoins) {
        return; // table doesn't exist
      }
      if (delta.isAdd()) {
        tableJoins.push(delta);
        if (isChanges) {
          addedJoins.push(delta);
        }
      } else {
        // remove
        deletedJoins.push(delta.negate());
      }
    };
    this.state.existing.map((d) => {
      update(d, false);
      update(d.swap(), false); // each delta should be added in both directions
    });
    this.state.updated.map((d) => {
      update(d, true);
      update(d.swap(), true); // each delta should be added in both directions
    });
    return result;
  }

  displayTables() {
    const { tables } = this.state;

    // calculate which joins to show, and which are added/deleted
    const addedJoins = {};
    const deletedJoins = {};
    const joinsPerTable = this.joinsPerTable(addedJoins, deletedJoins);

    const listOfTables = tables
      .filter((t) => {
        const { searchQuery } = this.state;
        const tableName = t.name().toLowerCase();
        if (searchQuery.length > 2) {
          if (tableName.includes(searchQuery.toLowerCase().trim())) {
            return true;
          }
          return false;
        }
        return true;
      })
      .map((t, i) => {
        const joins = joinsPerTable[t.uniqueName()];
        const added = addedJoins[t.uniqueName()];
        const deleted = deletedJoins[t.uniqueName()];

        return (
          <div className={style.joinTableContainer} key={i}>
            <div className={`${style.joinTableName} ${style.sticky}`}>
              <div className={`${flex.flex} ${flex.alignItemsCenter}`}>
                <div className={style.schemaTag}>{t.schema()}</div>
                <span className={style.tableName}>{t.name()}</span>
              </div>
            </div>
            <div className={style.joinsSection}>
              <div className={style.columnJoin}>
                <div className={`${flex.flex} ${flex.justifyContentBetween}`}>
                  <span>
                    <b>JOINs</b>
                  </span>
                  <span>
                    <b>Changes</b>
                  </span>
                </div>
              </div>
              {this.displayTableJoins(t, joins, added, deleted)}
            </div>
            <div className={style.addRelationshipContainer}>
              {this.displayJoinWizards(t)}
              <div className={style.addRelationshipButtonContainer}>
                <Button
                  variant="secondary"
                  size="small"
                  onClick={() => this.addJoinWizard(t)}
                >
                  Add relationship
                </Button>
              </div>
            </div>
          </div>
        );
      });
    if (tables.length > 0 && listOfTables.length === 0) {
      return (
        <div style={{ padding: '10px 30px' }}>
          <p>No matching tables found</p>
        </div>
      );
    }
    return listOfTables;
  }

  // list the joins for each table
  displayTableJoins(tableRef, joins, added, deleted) {
    const tableJoins = joins.map((delta, j) => {
      const isAdded = added.some((d) => d.equals(delta));
      const isDeleted = deleted.some((d) => d.equals(delta));
      const deletedClass = isDeleted ? style.deleted : '';

      return (
        <div
          className={`${style.columnJoin} ${flex.flex} ${flex.justifyContentBetween} ${flex.alignItemsCenter}`}
          key={j}
        >
          <div className={`${flex.flex} ${flex.alignItemsCenter}`}>
            {isDeleted ? (
              <button
                className={`${style.undoBtn} btn btn-outline-secondary btn-sm`}
                onClick={() => this.applyJoinDelta(delta)}
              >
                UNDO
              </button>
            ) : (
              <div
                className={style.removeJoin}
                onClick={() => this.applyJoinDelta(delta.negate())}
              >
                <div className={style.mdivd}>
                  <div className={style.mdiv}>
                    <div className={style.md} />
                  </div>
                </div>
              </div>
            )}
            <div className={`${deletedClass} ${flex.flex}`}>
              <div>
                <b>{delta.left().tov().name()}</b>
              </div>
              <div>.</div>
              <div>{delta.left().name()}</div>
              <div className={style.operator}>=</div>
              <div>
                <b>{delta.right().tov().name()}</b>
              </div>
              <div>.</div>
              <div>{delta.right().name()}</div>
            </div>
          </div>
          <div>
            <span>
              {isAdded ? (
                <div className={`${style.changeTag} ${style.addedTag}`}>
                  Click save to add
                </div>
              ) : (
                ''
              )}
              {isDeleted ? (
                <div className={`${style.changeTag} ${style.deletedTag}`}>
                  Click save to delete
                </div>
              ) : (
                ''
              )}
            </span>
          </div>
        </div>
      );
    });
    return tableJoins;
  }

  applyJoinDelta(delta) {
    const opposite = delta.negate();
    const swapped = opposite.swap();
    if (this.state.updated.some((d) => d.equals(opposite))) {
      // opposite already exists, so just remove it
      this.setState({
        updated: this.state.updated.filter((d) => !d.equals(opposite)),
      });
    } else if (this.state.updated.some((d) => d.equals(swapped))) {
      // opposite already exists, so just remove it
      this.setState({
        updated: this.state.updated.filter((d) => !d.equals(swapped)),
      });
    } else {
      // add join delta to list
      this.setState({
        updated: [...this.state.updated, delta],
      });
    }
  }

  // displays the joinwizards for the relevant table
  // position is the position of the table in the state array
  displayJoinWizards(t) {
    const { joinWizards, tables } = this.state;
    const position = tables.findIndex(
      (table) => t.name() === table.name() && t.schema() === table.schema(),
    );
    const display = joinWizards[position].map((a, i) => {
      return (
        <div key={`wizard_${i}`}>
          <form className={`${flex.flex} ${flex.alignItemsCenter}`}>
            <div className={style.joinTableLeft}>{tables[position].name()}</div>
            <span>.</span>
            {this.buildSelectColumnOptions(position, i, COLUMN1)}
            <span>=</span>
            {this.buildSelectColumnOptions(position, i, TABLE2)}
            <span>.</span>
            {this.buildSelectColumnOptions(position, i, COLUMN2)}
            <div
              onClick={() => this.removeWizard(position, i)}
              className={`${style.mdivd} ${style.closeWizard}`}
            >
              <div className={style.mdiv}>
                <div className={style.md} />
              </div>
            </div>
          </form>
        </div>
      );
    });
    return display;
  }

  removeWizard(positionInArray, positionInArrayOfArrays) {
    const { joinWizards } = this.state;
    const copyOfArray = joinWizards.slice();
    copyOfArray[positionInArray].splice(positionInArrayOfArrays, 1);
    this.setState({
      joinWizards: copyOfArray,
    });
  }

  addUpdatedDelta(positionInArray, positionInArrayOfArrays, e) {
    if (e) {
      e.preventDefault();
    } // prevents page refreshing on button click
    const { joinWizards } = this.state;
    const wizardObject = joinWizards[positionInArray][positionInArrayOfArrays];
    this.applyJoinDelta(this.buildDelta(wizardObject));
    this.removeWizard(positionInArray, positionInArrayOfArrays);
  }

  buildDelta(object) {
    const newDelta = new JoinDelta(
      new ColumnRef(object.table1, object.column1.name()),
      new ColumnRef(object.table2, object.column2.name()),
      true,
    );
    return newDelta;
  }

  // adds form for the relevant table to create a new relationship
  addJoinWizard(table) {
    const { tables } = this.state;
    const position = tables.findIndex(
      (t) => t.name() === table.name() && t.schema() === table.schema(),
    );
    const copyOfArray = this.state.joinWizards.slice();
    copyOfArray[position].push({
      [TABLE1]: tables[position],
    }); // create an empty object for each joinwizard. Populated via stageJoinUsingWizard function.
    this.setState({
      joinWizards: copyOfArray,
    });
  }

  // build the select options for the join wizard.
  buildSelectColumnOptions(positionInArray, positionInArrayOfArrays, key) {
    // get selected value for select form from state
    const { tables, joinWizards, columns } = this.state;

    const wizardObject = joinWizards[positionInArray][positionInArrayOfArrays];
    const keyValue = wizardObject[key];

    // determine whether to show columns or tables
    let content;
    if (key === COLUMN1) {
      // if column2 has been selected already, only show relevant columns (i.e. where the type matches or it's likely to be an id column). Otherwise just list all the columns
      content = wizardObject[COLUMN2]
        ? columns[positionInArray].filter(
            (c) =>
              c.type() === wizardObject[COLUMN2].type() ||
              c.name() === 'id' ||
              c.name().endsWith('_id'),
          )
        : columns[positionInArray];
    } else if (key === TABLE2) {
      content = tables;
    } else if (key === COLUMN2) {
      if (!wizardObject[TABLE2]) {
        return (
          <select value="..." className={style.customSelect} readOnly>
            <option>...</option>
          </select>
        );
      }
      const table2Selection = wizardObject[TABLE2];
      const typeOfColumn1 = wizardObject[COLUMN1]
        ? wizardObject[COLUMN1].type()
        : null;
      const position = tables.indexOf(table2Selection);

      // filter to columns that match the type, or that are likely to be ID columns
      content = typeOfColumn1
        ? columns[position].filter(
            (t) =>
              t.type() === typeOfColumn1 ||
              t.name() === 'id' ||
              t.name().endsWith('_id'),
          )
        : columns[position];
    }

    // get the position of the selected option
    const position =
      content.indexOf(keyValue) > -1 ? content.indexOf(keyValue) : '...';

    const buildOptions = content.map((item, i) => {
      return (
        <option key={`${key}_${i}`} value={i}>
          {item.name()}
        </option>
      );
    });
    return (
      <select
        value={position}
        className={style.customSelect}
        onChange={(e) =>
          this.stageJoinUsingWizard(
            positionInArray,
            positionInArrayOfArrays,
            key,
            content[e.target.value],
          )
        }
      >
        <option value="...">...</option>
        {buildOptions}
      </select>
    );
  }

  // store selected options from join wizard as an array of Objects
  stageJoinUsingWizard(
    positionInArray,
    positionInArrayOfArrays,
    key,
    newValue,
  ) {
    // take a copy of the joinwizards state.
    // take a copy of the right object and update it with the column or table ref, which is passed in via newValue
    // the result is an object that contains a class for table1, column1, table2, column2
    const { joinWizards } = this.state;
    const copyOfArray = joinWizards.slice();
    const wizardObject = copyOfArray[positionInArray][positionInArrayOfArrays];
    const copyOfObj = { ...wizardObject };

    // if table 2 value changes, set column2 values to null (as they depend on table2)
    if (key === TABLE2) {
      if (copyOfObj[TABLE2] && copyOfObj[TABLE2] !== newValue) {
        copyOfObj[COLUMN2] = null;
      }
    }

    copyOfObj[key] = newValue;
    copyOfArray[positionInArray][positionInArrayOfArrays] = copyOfObj;
    this.setState({
      joinWizards: copyOfArray,
    });
    // add form automatically if form is complete
    const expectedKeys = [TABLE1, COLUMN1, TABLE2, COLUMN2];
    const hasAllKeys = expectedKeys.every(function (k) {
      return k in copyOfObj;
    });
    const foundValues = Object.values(copyOfObj); // saves all object values in an array
    const addJoin =
      foundValues.length === 4 &&
      !foundValues.includes(null) &&
      !foundValues.includes(undefined) &&
      hasAllKeys;
    if (addJoin) {
      this.addUpdatedDelta(positionInArray, positionInArrayOfArrays);
    }
  }

  onSave() {
    this.setState({
      savingInProcess: true,
    });
    post('saving joins', '/configuration/joins', {
      deltas: this.state.updated,
    })
      .then(() => {
        // close modal
        this.props.closeModal();
        if (this.props.onSaved) {
          this.props.onSaved();
        }
        userAction('click-save-datasources-joins-configuration', {
          updated_joins: this.state.updated,
        });
      })
      .catch(() => {
        userAction('error-saving-joins-setup-page');
        this.setState({
          savingInProcess: false,
        });
      });
  }

  handleSearch(value) {
    const newValue = value.replace(' ', '_');
    this.setState({
      searchQuery: newValue,
    });
  }

  render() {
    const { onOpenConfigureTablesModal } = this.props;

    const controlSection =
      this.state.tables.length === 0 ? null : (
        <div
          className={`${style.controlContainer} ${flex.row} ${flex.alignItemsEnd} ${flex.justifyContentBetween}`}
        >
          <SearchInput
            value={this.state.searchQuery}
            onSearch={this.handleSearch}
            placeholder="Search tables"
          />
        </div>
      );

    return (
      <ConfigurePage
        title="Configure joins (table relationships)"
        controlSection={controlSection}
        onSave={this.onSave}
        saveButtonText="Save joins"
        loading={this.state.loading}
        loadError={this.state.loadError}
        cancel={this.props.closeModal}
        disabled={this.state.savingInProcess}
        showConfigureNote={this.state.tables.length === 0}
        onOpenConfigureTablesModal={onOpenConfigureTablesModal}
      >
        {this.displayTables()}
      </ConfigurePage>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onOpenConfigureTablesModal: () => {
      const closeModal = () => {
        dispatch(closeReactModal());
      };
      const reloadSchema = () => {
        dispatch(loadTables(false));
      };
      dispatch(
        openReactModal(
          <ModalContent onClose={closeModal} medium>
            <div style={{ height: '100%' }}>
              <SelectTables_LEGACY
                closeModal={closeModal}
                isModal
                reloadSchema={reloadSchema}
              />
            </div>
          </ModalContent>,
        ),
      );
    },
  };
};

export default connect(null, mapDispatchToProps)(SelectJoins);
